/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import { client } from 'lib/evi-api-gateway';
// utils
import formateObjToParamStr from '../utils/formateObjToParamStr';

const url = `${process.env.REACT_APP_API_URL}/admin/interview`;
const url2 = `${process.env.REACT_APP_API_URL}/interview_admin`;
const url3 = `${process.env.REACT_APP_API_URL}/admin`;
const url4 = `${process.env.REACT_APP_API_URL}/score`;

// 获取面試階段阶段列表
export async function getInterviewStageList() {
  return client.post({
    url: `${url}/get_phase_list`,
  });
}
// 获取面试小组列表数组
export async function getInterviewGroupList(id) {
  return client.post({
    url: `${url}/get_group_list`,
    form: {
      phase_id: id,
    },
  });
}
// 获取查询申请资料列表数据
export async function getInterviewUserList({
  id,
  offset = 0,
  limit = 999,
  parm,
  keyword,
}) {
  return client.post({
    url: `${url}/phase_user_list`,
    form: {
      phase_id: id,
      offset,
      limit,
      keyword,
      search: formateObjToParamStr(parm), // 查询条件
    },
  });
}
// 获取面试地点列表
export async function getInterviewLocationList({ id, date, starttime }) {
  return client.post({
    url: `${url}/get_interview_location_list `,
    form: {
      phase_id: id,
      date,
      starttime,
    },
  });
}
// 获取面试日期列表
export async function getInterviewDateList(id) {
  return client.post({
    url: `${url}/get_interview_date_list  `,
    form: {
      phase_id: id,
    },
  });
}
// 获取面试时段列表
export async function getInterviewTimeList({ id, date }) {
  return client.post({
    url: `${url}/get_interview_time_list`,
    form: {
      phase_id: id,
      date,
    },
  });
}
// 获取面试时间列表
export async function getGroupTimeList({
  school_app_id,
  phase_id,
  limit = 9999,
}) {
  return client.post({
    url: `${url}/group_time_list`,
    form: {
      school_app_id,
      phase_id,
      limit,
    },
  });
}
// 沒有 attend_time
export async function signinInterview({ ns_user_id, phase_id }) {
  return client.post({
    url: `${url}/sign_in`,
    form: {
      ns_user_id,
      phase_id,
    },
  });
}
// 有 attend_time
export async function resetAttendInterview({ ns_user_id, phase_id }) {
  return client.post({
    url: `${url2}/time/reset_attend`,
    form: {
      ns_user_id,
      phase_id,
    },
  });
}
// 修改面试时间
export async function addInterviewUser({ ns_user_id, phase_id, time_id }) {
  return client.post({
    url: `${url}/add_interview_user`,
    form: {
      ns_user_id,
      phase_id,
      time_id,
    },
  });
}
// 获取面试用户信息
export async function getInterviewUser({ ns_user_id, phase_id }) {
  return client.post({
    url: `${url}/get_interview_user`,
    form: {
      ns_user_id,
      phase_id,
    },
  });
}
// 获取某一个面试的新生列表
export async function getPhaseUsers({ timeId, phaseId }) {
  return client.post({
    url: `${url}/phase_user_list`,
    form: {
      search: timeId,
      phase_id: phaseId,
    },
  });
}
// 更改角色
export async function interviewTagList(params) {
  return client.post({
    url: `${url3}/interview_tag/get_staff_role_list`,
    form: {
      ...params,
    },
  });
}

// 顯示評分紀錄
export async function getScoreLogList({
  phase_id,
  ns_user_id,
  time_id,
  search,
  offset,
  limit,
}) {
  return client.post({
    url: `${url2}/score/get_log_list`,
    form: {
      ns_user_id,
      time_id,
      phase_id,
      search,
      offset,
      limit,
    },
  });
}

// 修改賬戶密碼
export async function getChangePassword(params) {
  return client.post({
    url: `${url3}/user/update_password`,
    form: {
      ...params,
    },
  });
}

export async function getConfig(params) {
  return client.post({
    url: `${url3}/ns_user_parent_display_config/get_config`,
    form: {
      ...params,
    },
  });
}
// 重置分數
export async function resetScore(params) {
  return client.post({
    url: `${url4}/reset`,
    form: {
      ...params,
    },
  });
}

// 得到新生列表的表格头部
export async function getNsUserHeaders({ phase_id }) {
  return client.post({
    url: `${url2}/setting/get_header`,
    form: {
      phase_id,
    },
  });
}
